import React from "react";

import TaskProgress from "./flyout/TaskProgress";
import type { BaseDataRowGeneration } from "./model";

interface GenerationTaskProps {
  generation: BaseDataRowGeneration;
  /** Run the generation workflow again. */
  onRetry(): void;
  /** Cancel the running generation. */
  onCancel(): void;
}

/** Progress of the generation workflow while it runs, or why its latest run failed; nothing otherwise. */
const GenerationTask: React.FC<GenerationTaskProps> = ({ generation, onRetry, onCancel }) => {
  const { noun, progress, failure, gate, cancel } = generation;

  if (progress) {
    return (
      <TaskProgress title={`Generating ${noun}`} phase={progress.phase} steps={progress.steps} onCancel={cancel.enabled ? onCancel : undefined} />
    );
  }

  if (!failure) return null;
  return (
    <TaskProgress
      error={{
        title: `Couldn't generate ${noun}`,
        reason: failure.reason,
        actions: gate.enabled ? [{ label: "Retry", primary: true, onClick: onRetry }] : [],
      }}
    />
  );
};

export default GenerationTask;
